import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import {
  getQuestionnaireSession,
  saveQuestionnaireStep,
  uploadQuestionnairePhoto,
  getPublicQuestionnaireDefinition,
} from '../services/questionnaire.service';

export function useQuestionnaireSession(token: string) {
  return useQuery({
    queryKey: ['questionnaire', token],
    queryFn: () => getQuestionnaireSession(token),
    enabled: !!token,
  });
}

export function useSaveQuestionnaireStep(token: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ step, answers }: { step: number; answers: Record<string, unknown> }) =>
      saveQuestionnaireStep(token, step, answers),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questionnaire', token] });
    },
  });
}

export function useUploadQuestionnairePhoto(token: string) {
  return useMutation({
    mutationFn: (file: File) => uploadQuestionnairePhoto(token, file),
  });
}

export function usePublicQuestionnaireDefinition() {
  return useQuery({
    queryKey: ['questionnaire-definition-public'],
    queryFn: () => getPublicQuestionnaireDefinition(),
    staleTime: 5 * 60 * 1000,
  });
}
